import React from "react";
import {connect} from "react-redux";
import {ff} from "@mc/mc-legacy";
import RegistraceApi from "../../api/gen/core/RegistraceApi";
import AgreementCheckboxField from "../field/AgreementCheckboxField";
import {withLang} from "../../i18n/withLang";
import {Message} from "../../i18n/Message";
import {i18n} from "../../i18n/i18n";
import * as CustomModalActions from "../../actions/CustomModalActions";

class UserAgreementFormSection extends React.Component<any> {

    constructor(props: any, context: any) {
        super(props, context);
        this.state = {};
    }

    showAgreementREG_GDPR_UCET = () => {
        RegistraceApi.getTextSouhlasu("REG_GDPR_UCET").then((text) => {
          text &&
            this.props.dispatch(
              CustomModalActions.showInfo(
                i18n(this.props.lang, "UserAgreementFormSection_gdpr_detail"),
                <div dangerouslySetInnerHTML={{ __html: text }} />,
                null,
                false,
                  false,
                {},
                // this.props.lang
              )
            );
        });
      };

      showAgreementREG_PODMINKY_PORTAL = () => {
        RegistraceApi.getTextSouhlasu("REG_PODMINKY_PORTAL").then((text) => {
          text &&
            this.props.dispatch(
              CustomModalActions.showInfo(
                i18n(this.props.lang, "UserAgreementFormSection_terms_detail"),
                <div dangerouslySetInnerHTML={{ __html: text }} />,
                null,
                false,
                  false,
                {},
                // this.props.lang
              )
            );
        });
      };

    componentDidMount(): void {
        RegistraceApi.getConsentsUrl().then((res) => {
            this.setState({
                consentsUrl: res,
            });
        });
    }

  render() {
    const { consentsUrl } = this.state;

    return (
      <ff.Base
        className={"user-agreement-form-section"}
        componentClass={AgreementCheckboxField}
        name={"agreement"}
        label={false}
        disabled={this.props.submitting}
        required
        componentLabel={
          <div className={"btn-link-main"}>
              {consentsUrl ?
                  <Message
                      lang={this.props.lang}
                      langKey={"UserAgreementFormSection_agreement2"}
                      getArg={(index) => {
                          switch (index) {
                              case 1:
                                  return (
                                      <a href={(window as any).appConfig.serverContextPath + "/redirect/consents"} target="_blank" className={"btn-link-main"}>
                                          {i18n(this.props.lang, "UserAgreementFormSection_gdpr_and_terms")}
                                      </a>
                                  );
                          }
                      }}
                  />
                  :
                  <Message
                      lang={this.props.lang}
                      langKey={"UserAgreementFormSection_agreement"}
                      getArg={(index) => {
                          switch (index) {
                              case 1:
                                  return (
                                      <a href="#" className={"btn-link-main"} key={1}
                                         onClick={this.showAgreementREG_GDPR_UCET}>
                                          {i18n(this.props.lang, "UserAgreementFormSection_gdpr")}
                                      </a>
                                  );

                              case 2:
                                  return (
                                      <a href="#" className={"btn-link-main"} key={2}
                                         onClick={this.showAgreementREG_PODMINKY_PORTAL}>
                                          {i18n(this.props.lang, "UserAgreementFormSection_terms")}
                                      </a>
                                  );
                          }
                      }}
                  />
              }
          </div>
        }
      />
    );
  }
}

export default withLang(connect()(UserAgreementFormSection));
